import { Field, Form, Formik } from "formik";
import React, { useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { inject } from "@vercel/analytics";
import * as Yup from "yup";
import { motion } from "framer-motion";

import Characters from "../components/Characters";
import DecorationFlash from "../components/DecorationFlash";
import Footer from "../components/Footer";

async function load() {
  let confetti = import("../components/confetti"); // Module loaded (export default)!
}

let discordAlert =
  "The Council of Legends will soon open its doors to the privileged Heaven Keys holders 🗝";

const ContactSchema = Yup.object().shape({
  email: Yup.string().email("Email incorrect").required("Adresse email requis"),
});
const Index = () => {
  const [loading, setLoading] = useState(false);
  const [index, setIndex] = useState(0);

  const characterRef = useRef();
  const largeCharacterRef = useRef();

  const dropInRocket = {
    hidden: {
      y: "25vh",
      x: "-25vw",
    },
    visible: {
      y: "0vh",
      x: "0vw",
      transition: {
        duration: 5,
        type: "spring",
        damping: 25,
        stiffness: 500,
      },
    },
  };

  const dropInTeam = {
    hidden: {
      y: "25vh",
    },
    visible: {
      y: "0vh",
      transition: {
        duration: 0.1,
        type: "spring",
        damping: 25,
        stiffness: 500,
      },
    },
  };

  const dropInWhiteStripeGame = {
    hidden: {
      x: "-25vw",
      y: "-25vw",
    },
    visible: {
      x: "0vw",
      y: "0vw",
      transition: {
        delay: 1,
        duration: 0.5,
        type: "spring",
        damping: 30,
        stiffness: 100,
        restDelta: 0.001,
      },
    },
  };

  const dropInPartner = {
    hidden: {
      x: "50vw",
    },
    visible: {
      x: "0vw",
      transition: {
        duration: 0.1,
        type: "spring",
        damping: 30,
        stiffness: 100,
        restDelta: 0.001,
      },
    },
  };

  const dropInDontMissOut = {
    hidden: {
      x: "-50vw",
    },
    visible: {
      x: "0vw",
      transition: {
        delay: 0.3,
        duration: 0.1,
        type: "spring",
        damping: 25,
        stiffness: 250,
      },
    },
  };

  const characters = [
    {
      id: 1,
      name: "CLEO",
      role: "Queen Of Egypt",
      description: (
        <>
          Forget the Cleopatra from history books.
          <br />
          Cleo is a Muay Thai champion with a knockout legacy, she took down
          Julius Caesar and Marcus Antonius back-to-back to claim the throne on
          her own terms.
        </>
      ),
      values: ["Strong", "Independent", "Determined", "Tenacious"],
      colors: ["#FC9B0E", "#FC9B0E", "#FC9B0E", "#FC9B0E"],
      image: "/assets/cleop2.webp",
      jar: "/assets/shadow_golden_vase.webp",
    },
    {
      id: 2,
      name: "FRIDA",
      role: "La Bruja De Los Colores",
      description: (
        <>
          Frida, an explosion of colour and chaos.
          <br />
          Armed with a mystical paintball gun and fueled by folklore and raw
          emotion, Frida turns every battlefield into a living canvas.
        </>
      ),
      values: ["Creative", "Fierce", "Mischievous", "Unstoppable"],
      colors: ["#6D28D9", "#6D28D9", "#6D28D9", "#6D28D9"],
      image: "/assets/FRIDA4.webp",
      jar: "",
    },
  ];

  const listPartners = {
    main: [],
    others: [
      {
        logo: "/assets/partners/BGA-white.png",
        name: "BGA",
      },
      {
        logo: "/assets/partners/hedera.svg",
        name: "hedera",
      },
      {
        logo: "/assets/partners//the_hbar_foundation.svg",
        name: "THF",
      },
      {
        logo: "/assets/partners//bpifrance.svg",
        name: "bpifrance",
      },
    ],
  };

  const team = [
    {
      image: "basile_masson.webp",
      role: (
        <>
          CEO <span className="text-[#5535C7] italic"> Co-founder</span>
        </>
      ),
      name: "Basile Masson",
      username: "Iterative Games",
    },
    {
      image: "neal_lausson.webp",
      role: (
        <>
          CTO <span className="text-[#5535C7] italic"> Co-founder</span>
        </>
      ),
      name: "Neal Lausson",
      username: "Iterative Games",
    },
    {
      image: "kim_ettinoff.webp",
      role: (
        <>
          Creative & Art{" "}
          <span className="text-[#5535C7] italic"> Director</span>
        </>
      ),
      name: "Kim Ettinoff",
      username: "Supercell Ankama",
    },
    {
      image: "marvin_gregor.webp",
      role: (
        <>
          Game <span className="text-[#5535C7] italic"> Designer</span>
        </>
      ),
      name: "Marvin Gregor",
      username: "Ubisoft Square Enix",
    },
    {
      image: "pierre_coneau.webp",
      role: (
        <>
          3D <span className="text-[#5535C7] italic"> Artist</span>
        </>
      ),
      name: "Pierre Coneau",
      username: "Wanadev",
    },
    {
      image: "markus_dalka.webp",
      role: (
        <>
          Marketing <span className="text-[#5535C7] italic"> Architect</span>
        </>
      ),
      name: "Markus Dalka",
      username: <span>Community Architect</span>,
    },
  ];

  function showHideAnswerFaq(index) {
    let element = document.getElementById("answer_faq_" + index.toString());
    let cell = document.getElementById("cell_faq_" + index.toString());
    if (element.className.includes("hidden")) {
      element.className = "show";
      cell.className = "button-63-selected text-black";
      for (let i = 1; i < 6; i++) {
        if (!(i === index)) {
          document.getElementById("answer_faq_" + i.toString()).className =
            "hidden";
          document.getElementById("cell_faq_" + i.toString()).className =
            "button-63 text-white";
        }
      }
    } else {
      element.className = "hidden";
      cell.className = "button-63 text-white";
    }
  }

  inject();

  return (
    <section className="overflow-hidden">
      <Helmet title="Legends Of The Past">
        {/*<!-- Google tag (gtag.js) -->*/}
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=G-CZENPTTH1C"
        ></script>
        <script>
          {`
          window.dataLayer = window.dataLayer || [];
          if( typeof window.dataLayer !== "undefined")
          {
            function gtag(){window.dataLayer.push(arguments);}
            gtag('js', new Date());

            gtag('config', 'G-CZENPTTH1C');
          }
          
          `}
        </script>
      </Helmet>
      {/* full + autoplay */}
      <section className="bg-gradient-to-br text-white from-[#014EFB] to-[#2AAEF5] z-50">
        <figure className="lg:absolute lg:flex z-50 items-end top-0 w-full border-t-[40px] lg:border-t-[80px] border-t-black">
          {/*<motion.a
            whileHover={{ scale: 1.1 }}
            href="https://neallausson.gitbook.io/litepaper-legends-of-the-past/intro/the-legends-of-the-past"
            target="_blank"
            className="
              text-white 
              lg:text-2xl
              z-50
              absolute 
              top-1
              right-[2rem]
              lg:-top-14 
              lg:right-[2rem] "
          >
            Whitepaper
          </motion.a>*/}

          {/*<motion.a
            whileHover={{ scale: 1.1 }}
            href="https://sentx.io/nft-marketplace/creators/legends-of-the-past"
            target="_blank"
            className="
              text-white 
              lg:text-2xl
              z-50
              absolute 
              top-1
              right-[8rem]
              lg:-top-14 
              lg:right-[12rem] "
          >
            Marketplace
          </motion.a>*/}
          <a href="/">
            <motion.img
              whileHover={{ scale: 1.1 }}
              src="/assets/Icon_legends_of_the_past.svg"
              title="LEGENDS OF THE PAST"
              alt=""
              className="absolute z-50 w-14 -top-1 lg:w-28 lg:-top-24 lg:left-0"
            />
          </a>
        </figure>
        <iframe
          className="z-50 w-full aspect-video"
          src="https://www.youtube.com/embed/DTGDlZxBDI4?autoplay=1&loop=1&mute=1&playlist=DTGDlZxBDI4"
          title="Discover Legends Of The Past"
          frameborder="0"
          allow="accelerometer; loop; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        ></iframe>
      </section>
      {/* LEGENDS OF THE PAST */}
      <section className=" relative bg-gradient-to-b from-[#FD6E8D] to-[#FFACD0] ">
        {/* Header & Social networks */}
        <figure className="lg:absolute lg:flex z-50 items-end top-0 w-full border-t-[0px] lg:border-t-[0px] border-t-black">
          <motion.img
            animate={{
              opacity: [0, 0, 1, 1],
            }}
            transition={{ duration: 3, times: [0, 0.72, 0.77, 1] }}
            src="/assets/decorations/golden_stripe.svg"
            title="LEGENDS OF THE PAST"
            alt=""
            className="mb-20 md:w-auto hidden lg:block  md:mb-0 md:w-[50rem] mb:-ml-12 lg:w-[70rem] lg:-ml-24 2xl:w-[85rem] 2xl:-ml-0"
          />
          <figure className="lg:hidden items-end top-0 w-full h-[10px]  bg-gradient-to-r from-[#AC6A33] via-[#E3DB5C] to-[#E5AE20] z-10"></figure>
          <img
            src="/assets/White_Legends_of_rhe_past_2line.svg"
            className="legend_title italic text-white mx-auto font-extrabold w-[18rem] lg:hidden mt-3 mb-2"
          ></img>
          {/* Social networks */}
          <motion.ul
            animate={{
              opacity: [0, 0, 1, 1],
            }}
            transition={{ duration: 3, times: [0, 0.72, 0.77, 1] }}
            className="bg-cover header_social_networks lg:-ml-36 pl-3 pr-12 py-2 lg:flex items-center"
            style={{
              backgroundImage: "url(/assets/decorations/curved_trapezium.svg",
            }}
          >
            <li className="mr-3">
              <a href="https://discord.gg/wYB7bsjVQ5" target="_blank">
                <motion.img
                  whileHover={{ scale: 1.1 }}
                  animate={{
                    x: ["5vw", "5vw", "5vw", "0vw"],
                    y: ["5vw", "5vw", "5vw", "0vw"],
                    rotate: [30, 30, 30, 12],
                    opacity: [0, 0, 1, 1],
                  }}
                  transition={{ duration: 6, times: [0, 0.35, 0.36, 0.6] }}
                  src="/assets/social_networks/discord_button.svg"
                  alt="Discord"
                  title="Discord"
                  className="discord z-50 h-10 lg:h-auto absolute right-40 sm:right-32 top-76 sm:top-60 lg:relative lg:top-0 lg:right-0 rotate-12 lg:rotate-0"
                />
              </a>
            </li>
            <li>
              <a href="https://twitter.com/legends_of_past" target="_blank">
                <motion.img
                  whileHover={{ scale: 1.1 }}
                  animate={{
                    x: ["8vw", "8vw", "8vw", "0vw"],
                    y: ["8vw", "8vw", "8vw", "0vw"],
                    rotate: [50, 50, 50, 30],
                    opacity: [0, 0, 1, 1],
                  }}
                  transition={{ duration: 6, times: [0, 0.35, 0.36, 0.6] }}
                  src="/assets/social_networks/twitter_button.svg"
                  alt="Twitter"
                  title="Twitter"
                  className="twitter z-50 h-10 lg:h-auto absolute right-8 sm:right-24 top-64 sm:top-[21rem] lg:relative lg:top-0 lg:right-0 rotate-[30deg] lg:rotate-0"
                />
              </a>
            </li>
          </motion.ul>
        </figure>
        {/* Decoration */}
        <motion.span
          animate={{ opacity: [0, 0, 1, 0, 0] }}
          transition={{ duration: 3, times: [0, 0.65, 0.7, 0.75, 1] }}
          className="bg-[#FFF0F7] z-40 absolute left-0 top-0 w-full h-screen "
        ></motion.span>
        <figure className="w-auto lg:w-1/2 hidden lg:flex justify-end  relative lg:pr-20 -mb-10 z-40 lg:-mb-34 xl:-mb-64 -mt-6 md:mt-0">
          <motion.img
            animate={{
              x: ["-5vw", "-5vw", "-5vw", "0vw"],
              opacity: [0, 0, 1, 1],
            }}
            transition={{ duration: 3, times: [0, 0.68, 0.69, 0.71] }}
            src="/assets/decorations/multi_particle.svg"
            title="LEGENDS OF THE PAST"
            alt=""
            className="
              relative 
              hidden 
              lg:block 
              z-10 
              h-52 
              top-32 
              xl:top-2 
              2xl:top-2
              
              -left-20 
              md:left-[7rem]
              2xl:left-[9rem]
              3xl:left-[12rem]

              md:h-[24rem] 
              2xl:h-[32rem]
              3xl:h-[37rem]
              3xl:-mb-[4rem]"
          />
          <motion.img
            animate={{
              x: ["3vw", "3vw", "3vw", "0vw"],
              y: ["3vw", "3vw", "3vw", "0vw"],
              rotate: [30, 30, 30, 0],
              opacity: [0, 0, 1, 1],
            }}
            transition={{ duration: 6, times: [0, 0.35, 0.36, 0.6] }}
            src="/assets/decorations/arrow_left_top.svg"
            title="LEGENDS OF THE PAST"
            alt=""
            className="
              absolute 
              top-36 
              md:top-52 
              xl:top-32 
              h-auto 
              right-16 
              md:right-36 
              lg:right-10 
              2xl:right-20"
          />
          <motion.img
            animate={{
              x: ["3vw", "3vw", "3vw", "0vw"],
              y: ["3vw", "3vw", "3vw", "0vw"],
              rotate: [30, 30, 30, 0],
              opacity: [0, 0, 1, 1],
            }}
            transition={{ duration: 6, times: [0, 0.35, 0.36, 0.6] }}
            src="/assets/decorations/arrow_bottom.svg"
            title="LEGENDS OF THE PAST"
            alt=""
            className="
              absolute 
              top-44 
              md:top-36 
              lg:top-44 
              x:top-44 
              h-10
              xl:h-auto 
              right-10 
              md:right-28 
              lg:right-32 
              xl:-right-20
              2xl:-right-36"
          />
        </figure>
        <motion.span
          animate={{ x: ["-120vw", "-120vw", "-120vw", "-50vw"] }}
          transition={{ duration: 3, times: [0, 0.2, 0.45, 0.6] }}
          className="bg-[#FFF0F7]/90 
            -left-[20rem]
            absolute 
            hidden
            w-[130%] 
            md:h-[8rem]
            2xl:h-[10rem]
            3xl:h-[12.5rem]
            bulk-parrallelogram 
            lg:-left-[15rem]
            2xl:-left-[17rem]
            3xl:-left-[21rem]
            -bottom-20
            xl:block
            xl:bottom-[12rem]
            2xl:bottom-[15rem]
            3xl:bottom-[18.5rem]"
        />
        {/* Cleo Boxing */}
        <aside className="flex relative justify-between items-center lg:-mt-0">
          <motion.div
            animate={{
              x: ["-5vw", "-5vw", "-5vw", "0vw"],
              opacity: [0, 0, 1, 1],
            }}
            transition={{ duration: 3, times: [0, 0.75, 0.76, 0.9] }}
            className="absolute hidden lg:block w-28 md:w-56 left-2/4 md:left-1/4 h-full content[''] bg-[url('../assets/particle-2.svg')] bg-contain bg-no-repeat bg-bottom bottom-0 md:bottom-28 lg:bottom-10 xl:bottom-20 z-30"
          ></motion.div>
          <figure className="relative flex items-start z-40 -mb-8 mt-28 sm:mt-20 w-auto">
            <motion.img
              initial={{ x: "-150vw", scale: 2 }}
              animate={{ x: "0vw", scale: 1 }}
              transition={{ delay: 1.8, duration: 0.4 }}
              src="/assets/cleop_boxing.png"
              alt="Cleop boxing"
              title="LEGENDS OF THE PAST"
              className="
                hidden
                lg:inline-flex
                z-10
                w-[40rem]
                lg:w-[45rem]
                2xl:w-[54rem]
                3xl:w-[63rem]
                lg:max-width-[100%]
                mt-10
                lg:-mt-20
                -ml-6
                lg:-ml-8 
                lg:-mb-[2rem]
                2xl:-ml-10
                2xl:-mt-[8rem]
                2xl:-mb-[2rem]
                3xl:-mb-[2rem]
                3xl:-mt-[8rem]"
            />
            <motion.img
              initial={{ x: "-150vw", scale: 2 }}
              animate={{ x: "0vw", scale: 1.2 }}
              transition={{ delay: 1.8, duration: 0.4 }}
              src="/assets/cleop_boxing.webp"
              alt="Cleop boxing"
              title="LEGENDS OF THE PAST"
              className="
                z-10
                w-[25rem]
                mt-10
                -ml-6
                mb-5
                lg:hidden"
            />
            <motion.img
              animate={{
                x: ["-15vw", "-15vw", "-15vw", "0vw"],
                opacity: [0, 0, 1, 1],
              }}
              transition={{ duration: 3, times: [0, 0.45, 0.46, 0.55] }}
              src="/assets/decorations/multi_particle_mobile.svg"
              title="LEGENDS OF THE PAST"
              alt=""
              className="w-full lg:hidden absolute -right-4 -top-[9rem]"
            />
          </figure>
          <motion.span
            initial={{ x: "-150vw" }}
            animate={{ x: "0vw" }}
            transition={{ delay: 0.6, duration: 0.4 }}
            className="bg-[#FFF0F7]/90 right-0 absolute w-full bottom-1/3 h-20 lg:hidden"
          />
          <motion.span
            initial={{ x: "-150vw" }}
            animate={{ x: "0vw" }}
            transition={{ delay: 0.8, duration: 0.4 }}
            className="bg-[#FFF0F7]/90 right-0 absolute w-full h-20 lg:hidden bottom-6 md:bottom-3"
          />
          {/* Content */}
          <div className="absolute hidden lg:block top-40 w-full lg:w-auto text-center lg:top-0 lg:static">
            <h1 className="legend_title italic text-white lg:text-black font-bold text-6xl 2xl:text-8xl text-center lg:text-right text-shadow--teal lg:mt-12 xl:mt-20 2xl:mt-20">
              <motion.span
                initial={{ x: "-150vw", scale: 0.2 }}
                animate={{ x: "0vw", scale: 1 }}
                transition={{ delay: 1.7, duration: 0.4 }}
                className="
                  block 
                  bg-cover 
                  h-[9.12rem]
                  w-[26.448rem]
                  -mt-[6rem]
                  mr-[4rem]
                  2xl:mr-[2.5rem]
                  2xl:h-[11.88rem]
                  2xl:w-[34.65rem]
                  2xl:-mt-[14rem]
                  3xl:mr-[4rem]
                  3xl:h-[14.4rem]
                  3xl:w-[42rem]
                  3xl:-mt-[15rem]"
                style={{
                  backgroundImage:
                    "url(/assets/White_Legends_of_rhe_past_2line.svg)",
                }}
              ></motion.span>
              <motion.span
                initial={{ x: "-150vw" }}
                animate={{ x: "0vw" }}
                transition={{ delay: 1.55, duration: 0.4 }}
                className="
                  block 
                  lg:absolute 
                  lg:bottom-3 
                  2xl:bottom-4
                  3xl:bottom-5
                  w-full  
                  lg:p-6 
                  lg:bg-[#FFF0F7]/90 
                  lg:left-0 
                  grid 
                  justify-end"
              >
                <motion.img
                  animate={{
                    x: ["-5vw", "-5vw", "-3.125vw", "0vw"],
                    opacity: [0, 0, 0, 1],
                  }}
                  transition={{ duration: 7, times: [0, 0.2, 0.35, 0.6] }}
                  src="/assets/RewriteHistory.webp"
                  className="
                  w-[38rem] 
                  -mb-[2.25rem] 
                  -mt-[0.25rem] 
                  mr-[7rem]
                  2xl:w-[50rem]
                  2xl:-mb-[2.5rem] 
                  2xl:-mt-[0.5rem] 
                  3xl:w-[62rem] 
                  3xl:-mb-[2.8rem] 
                  3xl:mt-[0rem]"
                ></motion.img>
              </motion.span>
            </h1>
          </div>
        </aside>
      </section>
      <DecorationFlash
        pseudoElements="before:border-b-[#FFACD0] after:bg-[#FFACD0]"
        figureBackground="bg-[#251015] lg:bg-black"
      />

      {/* Aspire to a legendary life */}
      <section className="flex relative md:pb-0 bg-black z-40 -mt-1  justify-end text-xl lg:text-3xl font-bold md:pr-5 w-full">
        <div className="is-legendary mt-6 2xl:mt-10 before:absolute after:absolute bottom-4 md:-bottom-6 -right-8 sm:right-4 lg:right-28 z-30 scale-[0.8] lg:scale-110 xl:scale-125 2xl:scale-150 ml-auto relative max-w-sm lg:w-full before:right-3/4 before:bottom-[4.9rem] before:w-full before:h-14 before:content[''] before:bg-[url('../assets/trame-2.svg')] before:bg-contain before:bg-no-repeat before:bg-bottom ">
          <h2 className="italic px-10 lg:px-16 py-2 lg:py-4 parrallelogram relative z-10 bg-[#8626EC] flex flex-col lg:-top-4">
            <span className="text-radial-gradient">Aspire to a</span>
            <span className="mt-12 lg:mt-12 text-radial-gradient">
              Rewrite History!
            </span>
          </h2>
          <figure
            className="lg:top-20 top-12 bg-cover text-right absolute w-full max-w-xl right-7 italic lg:right-10 z-10"
            style={{
              backgroundImage: "url(/assets/decorations/trame.svg)",
            }}
          >
            <span className="parrallelogram bg-[#4B1D77] pr-8 lg:pr-16 lg:pl-28 pl-8 py-2 inline-block lg:absolute lg:-top-10 lg:-right-6   lg:ml-auto ">
              <span className="text-radial-gradient">legendary life.</span>
            </span>
          </figure>
        </div>
      </section>
      <aside className="border-b-[20px] md:border-b-[40px] border-b-[#251015] border-t-[20px] md:border-t-[40px] border-t-[#00007A]">
        <DecorationFlash
          pseudoElements="before:border-b-[#00007A] after:bg-[#00007A] before:border-b-[20px] before:md:border-b-[40px] md:h-24"
          figureBackground="bg-[#251015]"
        />
      </aside>

      {/* What is Legends of the Past ? */}
      <section className="relative z-10 flex flex-col-reverse items-center lg:items-start lg:flex-row overflow-hidden lg:justify-between bg-gradient-to-br text-white from-[#014EFB] to-[#2AAEF5]">
        {/* Confetti */}
        <canvas
          class="confetti absolute h-full w-full z-20 left-0 top-0"
          id="canvas"
          onLoad={load()}
        ></canvas>

        <aside className="relative z-50 md:-z-0">
          <figure className="relative overflow-hidden -mb-4">
            <img
              src="/assets/boxing.webp"
              title="What is Legends of the Past ?"
              alt="boxing"
              className="z-20 relative w-96 hidden lg:block lg:w-auto 2xl:left-[15rem]"
            />
            <img
              src="/assets/boxing.webp"
              title="What is Legends of the Past ?"
              alt="boxing"
              className="z-20 relative w-96 block lg:hidden left-20"
            />
          </figure>
          <span
            className="bg-right-top hidden lg:block top-[18rem] z-10 w-full h-full bg-no-repeat absolute left-8 xl:left-[9rem]  2xl:top-[23rem] 2xl:left-[18rem]"
            style={{
              backgroundImage: "url(/assets/decorations/vertical_gold_red.svg)",
            }}
          />
          <span
            className="
            bg-right-top 
            bg-contain 
            hidden 
            lg:block 
            -top-[6rem] 
            z-10 
            w-full  
            h-[2200px] 
            bg-no-repeat 
            absolute 
            xl:left-44 
            2xl:left-[20rem] "
            style={{
              backgroundImage: "url(/assets/decorations/vertical_gold_red.svg)",
            }}
          />
        </aside>

        <span
          className="bg-right-bottom lg:hidden top-24 z-10 w-40 left-0 h-full bg-no-repeat absolute"
          style={{
            backgroundImage: "url(/assets/striped-shape.svg)",
          }}
        />
        <article className="flex flex-col pb-10 relative sm:pr-8">
          {/* Top decoration */}
          <figure
            className="h-40 -top-20 w-full -right-10 sm:-right-20 lg:-right-40 absolute bg-contain 2xl:h-[15rem]"
            style={{
              backgroundImage: "url(/assets/decorations/Trame_amphore.svg)",
            }}
          />
          {/* Title underlined */}
          <figure
            className="h-[180px] sm:h-[400px] -top-16 sm:-top-20 -left-24 sm:-left-24 lg:-top-28 bg-no-repeat w-full sm:w-2/3 absolute bg-contain"
            style={{
              backgroundImage: "url(/assets/decorations/elbow_gold_red.svg)",
            }}
          />
          <h2
            className="
            is-title 
            max-w-4xl 
            mx-auto 
            uppercase 
            text-shadow--blue 
            italic 
            text-3xl 
            text-center 
            lg:max-w-7xl 
            mb-20 
            sm:mb-28 
            lg:text-4xl 
            2xl:text-[2.6rem]
            3xl:text-5xl 
            font-bold 
            pl-0 
            md:pl-16 
            md:pr-5 
            pt-2 
            sm:pt-8
            lg:mt-6 
            z-20 
            2xl:pl-32
            2xl:pt-32
            md:mt-2
            2xl:-mt-0
            3xl:-mt-16"
          >
            Midcore Mobile Game
          </h2>
          <aside className="sm:pl-44 pt-10 lg:pt-0 xl:pt-10 2xl:pt-24 px-3 sm:pr-0 text-base md:text-xl 2xl:text-2xl">
            <p className="text-white font-normal text-center md:text-justify px-6 sm:px-0 sm:max-w-2xl mx-auto text-base md:text-lg lg:text-xl 2xl:text-[1.6rem] leading-relaxed lg:leading-8">
              Multiplayer mobile action game where reinvented historical figures
              clash in epic battles.
              <br className="hidden sm:block" />
              Easy to pick up, full of chaos and clutch comebacks.
              <br />
              <br />
              <span className="uppercase italic font-bold text-white text-lg md:text-xl 2xl:text-2xl">
                Powered by{" "}
                <span
                  style={{
                    display: "inline-block",
                    animation: "bounceShadow 1.6s ease-in-out infinite",
                    textShadow: "0 1px 2px #F5E748, 0 0 2px #F5E748",
                  }}
                >
                  ITERATIVE GAMES
                </span>
              </span>
              <style>
                {`
                @keyframes bounceShadow {
                  0%, 100% {
                    transform: translateY(0);
                  }
                  50% {
                    transform: translateY(-4px);
                  }
                }
              `}
              </style>
              <style>
                {`
                @keyframes glow {
                  0%, 100% {
                    text-shadow: 0 0 1px #F5E748, 0 0 2px #F5E748;
                  }
                  50% {
                    text-shadow: 0 0 2px #fff, 0 0 3px #F5E748;
                  }
                }
              `}
              </style>
              <img
                src="/assets/soon.png"
                alt="Coming Soon"
                className="mx-auto mt-6 w-52 md:w-72 2xl:w-[22rem]"
              />
            </p>
          </aside>
        </article>
      </section>
      <DecorationFlash
        pseudoElements="before:border-b-violet-700 after:bg-violet-700 relative z-[5]"
        figureBackground="bg-[#251015]"
      />
      {/* Global Tournament - Early Access (Short Version) */}
      <section className="w-full relative pb-10 lg:pb-0 2xl:-mb-10 before:md:block before:absolute lg:before:-top-24 before:-top-12 before:md:-top-0 before:left-[50%] before:md:left-[70%] lg:before:left-[12%] z-0 before:w-2/3 before:md:w-1/3 before:h-full before:content[''] before:bg-contain before:bg-no-repeat before:bg-top">
        <img
          src="/assets/INFINTY_JAR_BACKGROUND.jpg"
          className="lg:-ml-[2rem] lg:h-[35rem] 2xl:-ml-[15rem] 2xl:h-[50rem] 3xl:-ml-[4rem] w-auto top-0"
        />

        <motion.img
          src="/assets/INFINTY_JAR.png"
          animate={{
            y: ["1vw", "-3vw", "1vw"],
            transition: {
              duration: 10,
              times: [0, 0.5, 1],
              repeatType: "loop",
              repeat: Infinity,
              type: "tween",
              damping: 25,
              stiffness: 500,
            },
          }}
          className="absolute lg:-ml-[2rem] lg:h-[35rem] 2xl:-ml-[15rem] 2xl:h-[50rem] 3xl:-ml-[4rem] w-auto top-0"
        />

        <div className="relative lg:absolute lg:top-8 lg:right-0 z-30 2xl:mr-14 3xl:mr-28 lg:mt-0">
          <h2 className="uppercase text-shadow--blue text-2xl lg:text-6xl lg:pr-0  lg:-mr-10 text-white font-bold italic text-center px-6 mt-4">
            KPIS
          </h2>

          <aside className="text-base text-white top-0 right-0">
            <p className="font-montserrat w-full sm:max-w-2xl mx-auto text-center md:text-justify font-normal px-14 2xl:text-[1.6rem] 2xl:px-2 mt-20">
              After 3y of R&amp;D, we ran a 7-day playtest (July 2025).
              <br />
              <br />
              ✅ 2.5M games played worldwide
              <br />
              ✅ Retention: D1 50% | D7 30% (vs. ~30% / 15% industry)
              <br />
              ✅ Engagement: 75 min/day
              <br />✅ Growth: 100% organic. Zero UA spent.
            </p>

            <style>
              {`
            @keyframes bounceShadow {
              0%, 100% {
                transform: translateY(0);
              }
              50% {
                transform: translateY(-4px);
              }
            }
          `}
            </style>
            {/*
          <div className="mt-8 flex justify-center">
          <a
            href="https://legends-of-the-past.typeform.com/hbarbarians"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              animation: "glowPulse 2s infinite"
            }}
            className="animate-pulse transform hover:scale-105 hover:shadow-2xl bg-[#FFD700] hover:bg-[#e6c200] text-black font-bold italic uppercase text-base md:text-lg px-6 py-3 rounded-xl transition-all duration-300"
          >
            🎮 Join Tournament
          </a>

          <style>{`
            @keyframes glowPulse {
              0%, 100% { box-shadow: 0 0 0px #FFD700; }
              50% { box-shadow: 0 0 12px #FFD700; }
            }
          `}</style>

          </div>
          */}
          </aside>
        </div>

        <div className="trapezeInfinityJar absolute bg-[#25191E] w-full h-full top-0 hidden lg:block"></div>
        <div className="trapezePlusInfinityJar absolute bg-[#25191E] w-full h-full top-0 hidden lg:block"></div>
        <div className="trapezeInfinityJarMobile absolute bg-[#25191E] w-full h-full top-0 lg:hidden"></div>
        <div className="trapezePlusInfinityJarMobile absolute bg-[#25191E] w-full h-full top-0 lg:hidden"></div>
      </section>

      {/*CLEOP*/}
      <section className="w-full relative primary-radial-gradient-background-carousel pb-10 lg:pb-0 2xl:-mb-10 before:md:block before:absolute lg:before:-top-24 before:-top-12 before:md:-top-0 before:left-[50%] before:md:left-[70%] lg:before:left-[12%] z-0 before:w-2/3 before:md:w-1/3 before:h-full before:content['']  before:bg-contain before:bg-no-repeat before:bg-top">
        <h2 className="uppercase text-[4rem] -left-16 pt-16 md:pt-0 lg:text-[10rem] relative lg:absolute lg:right-10 lg:top-24 z-10 text-[#57B3FA] text-opacity-80 p-4 lg:text-right font-bold italic">
          {characters[index].name}
        </h2>
        <div className="hidden lg:flex w-full relative z-30 lg:-mt-8">
          <div className="w-1/12 item-center justify-center m-auto">
            <button
              type="button"
              onClick={() => largeCharacterRef.current.scrollPrev()}
              className="w-full"
            >
              <figure className="m-auto">
                <img src="/assets/arrow-left.svg" alt="" className="m-auto" />
              </figure>
            </button>
          </div>

          <div className="w-10/12 lg:flex">
            <div className="max-w-lg 2xl:ml-[6rem] 3xl:ml-[15rem] lg:mt-[6rem] 2xl:mt-[10rem] 3xl:mt-[10rem]">
              <div className="flex relative flex-row text-shadow--blue bg-[#FF6BBB] py-8 px-8 md:py-2 md:px-8  before:absolute before:border-y-[56px] before:md:border-y-[36px] before:2xl:border-y-[48px] before:border-r-[56px] before:border-y-transparent before:border-r-[#FF6BBB] before:-left-12 before:w-0 before:h-0 ">
                <figure className="-mt-16 lg:-mt-14 bottom-0">
                  <img
                    src={characters[index].jar}
                    title=""
                    alt=""
                    className=" w-3 sm:w-16"
                  />
                </figure>
                <h2 className="uppercase md:text-7xl  2xl:text-8xl text-white font-bold italic ">
                  {characters[index].name}
                </h2>
              </div>
              <div className="bg-[#0605454F] bg-opacity-30 text-white pb-4 px-4 lg:px-10 lg:pb-10 relative">
                <figure className="absolute bottom-44 -left-5">
                  <img src="/assets/purple_star.svg" alt="" className="" />
                </figure>
                <div className="relative -right-24 -top-2">
                  <div className="semi-curved-parrallelogram relative bg-[#4B1D77] z-10">
                    <h3 className="italic text-white relative z-20 w-3/4 ml-auto mr-8 text-2xl font-bold py-4">
                      {characters[index].role}
                    </h3>
                  </div>
                  <div className="italic bg-[#F5E748] text-white semi-curved-parrallelogram absolute z-0 top-2 left-4 h-full w-full ml-auto mr-8 md:text-2xl font-bold py-4" />
                </div>
                <p className="mt-2 text-justify">
                  {characters[index].description}
                </p>
                VALUES
                <br />
                <div className="flex flex-wrap">
                  {characters[index].values.map((value, i) => (
                    <span className="curved-parrallelogram-right px-10 md:px-12 py-2 mr-6 mt-4 bg-black relative">
                      <div
                        className="absolute inset-[2px] curved-parrallelogram-right bg-[#F5E748]"
                        style={{
                          background: characters[index].colors[i],
                        }}
                      />
                      <span className="-ml-6 relative z-10">{value}</span>
                    </span>
                  ))}
                </div>
              </div>
            </div>
            <Characters
              ref={largeCharacterRef}
              characters={characters}
              setIndex={setIndex}
            />
          </div>
          <div className="w-1/12 item-center justify-center m-auto">
            <button
              type="button"
              onClick={() => largeCharacterRef.current.scrollNext()}
              className="w-full"
            >
              <figure className="m-auto">
                <img src="/assets/arrow-right.svg" alt="" className="m-auto" />
              </figure>
            </button>
          </div>
        </div>

        <div className="block lg:hidden">
          <div className="flex w-full relative z-40 -mb-20">
            <div className="w-1/12 item-center justify-center m-auto">
              <button
                type="button"
                onClick={() => characterRef.current.scrollPrev()}
                className="w-full"
              >
                <figure className="m-auto">
                  <img src="/assets/arrow-left.svg" alt="" className="m-auto" />
                </figure>
              </button>
            </div>

            <div className="w-10/12 flex">
              <Characters
                ref={characterRef}
                characters={characters}
                setIndex={setIndex}
              />
            </div>
            <div className="w-1/12 item-center justify-center m-auto">
              <button
                type="button"
                onClick={() => characterRef.current.scrollNext()}
                className="w-full"
              >
                <figure className="m-auto">
                  <img
                    src="/assets/arrow-right.svg"
                    alt=""
                    className="m-auto"
                  />
                </figure>
              </button>
            </div>
          </div>
          <div className="mx-10">
            <div className="max-w-lg mx-auto relative z-30">
              <div className="flex relative items-center flex-row text-shadow--blue bg-[#FF6BBB] pt-8 sm:pb-8 px-8  before:-mt-5 before:sm:mt-0 before:absolute before:sm:border-y-[56px] before:border-y-[20px] before:border-r-[20px] before:sm:border-r-[56px] before:border-y-transparent before:border-r-[#FF6BBB]  before:sm:-left-12 before:-left-5 before:w-0 before:h-0 ">
                <figure className="-mt-16">
                  <img
                    src={characters[index].jar}
                    title=""
                    alt=""
                    className="w-[3rem] sm:w-[4rem]"
                  />
                </figure>
                <h2 className="uppercase -mt-5 sm:mt-0 text-6xl sm:text-8xl text-white font-bold italic">
                  {characters[index].name}
                </h2>
              </div>
              <div className="bg-[#0605454F] bg-opacity-30 text-white pb-4 px-4 lg:px-10 lg:pb-10 relative">
                <figure className="hidden md:block absolute bottom-44 -left-5">
                  <img src="/assets/purple_star.svg" alt="" className="" />
                </figure>
                <div className="relative -right-6">
                  <div className="semi-curved-parrallelogram relative bg-[#4B1D77] z-10">
                    <h3 className="italic text-white relative z-20 md:w-1/2 md:ml-auto ml-14 md:mr-8 text-lg md:text-2xl font-bold py-1 md:py-4">
                      {characters[index].role}
                    </h3>
                  </div>
                  <div className="italic bg-[#F5E748] text-white semi-curved-parrallelogram absolute z-0 top-0.5 md:top-2 left-1 md:left-4 h-full w-full ml-auto mr-8 text-2xl font-bold py-4" />
                </div>
                <p className="font-montserrat mt-8 md:mt-16 text-sm md:text-base">
                  {characters[index].description}
                </p>
                <br />
                <h4 className="text-sm md:text-base">VALUES</h4>
                <br />
                <div className="flex flex-wrap">
                  {characters[index].values.map((value, i) => (
                    <span className="curved-parrallelogram-right px-10 md:px-12 py-2 mr-2 md:mr-6 mt-4 bg-black relative">
                      <div
                        className="absolute inset-[2px] curved-parrallelogram-right bg-[#F5E748]"
                        style={{
                          background: characters[index].colors[i],
                        }}
                      />
                      <span className="-ml-6 relative z-10 text-xs md:text-base">
                        {value}
                      </span>
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <figure className="absolute bottom-0 right-0">
          <img src="/assets/trame.svg" alt="" />
        </figure>
      </section>

      <DecorationFlash
        pseudoElements="before:border-b-violet-700 after:bg-violet-700 relative z-[5]"
        figureBackground="bg-[#251015]"
      />

      {/* MOBILE GAME */}
      <section className="primary-gradient-background border-b-8 border-b-black relative before:hidden before:md:block before:absolute before:top-0 before:right-0 z-0 before:w-1/3 before:h-full before:content[''] before:bg-[url('../assets/boxed_black.svg')] before:bg-cover before:bg-no-repeat before:bg-center">
        <figure className="relative z-40 lg:z-0 lg:-mb-8 after:border-b-[40px] after:border-b-black  before:absolute before:bottom-12 before:lg:bottom- before:z-10 before:w-full before:h-8 before:left-0 before:bg-black after:bg-[#00007A] after:absolute after:w-full after:h-full after:top-0 after:left-0">
          <span
            className="bg-cover hidden z-20 bg-no-repeat absolute w-full h-full"
            style={{
              backgroundImage: "url(/assets/decorations/curved_gold_line.svg)",
            }}
          />
          <img
            src="/assets/decorations/curved_gold_line.svg"
            title="OUR GOAL"
            alt="rocket"
            className="w-full hidden lg:block relative z-20"
          />
          <img
            src="/assets/decorations/curved_gold_line_mobile.svg"
            title="OUR GOAL"
            alt="rocket"
            className="w-full lg:hidden relative z-20"
          />
        </figure>
        {/* Title */}
        <figure
          className="
          text-shadow-blue 
          border-t-black 
          before:-z-0 
          relative 
          bg-black 
          before:absolute 
          block
          w-[70%]
          md:w-[45%] 
          2xl:w-[40%]
          before:w-0 
          italic 
          font-bold 
          text-white 
          text-xl 
          sm:text-4xl 
          pl-10 
          sm:pr-10  
          sm:pl-20 
          lg:pr-40 
          before:-top-6 
          lg:before:top-0 
          before:-right-20 
          py-5 
          before:border-t-[100px] 
          before:border-t-transparent 
          before:border-l-[100px] 
          before:border-l-black"
        >
          <motion.img
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={dropInRocket}
            src="/assets/rocket.webp"
            title="OUR GOAL"
            alt="rocket"
            className="h-[7rem] lg:h-[9rem] 2xl:h-[11rem]  absolute top-2 -right-28  lg:-right-20  lg:-top-3 z-10 "
          />
          <figcaption>
            <h2 className="z-50 relative -left-8 -mr-10 text-5xl lg:text-6xl lg:pr-0 2xl:text-7xl lg:-mr-10">
              MOBILE GAME
            </h2>
          </figcaption>
        </figure>
        <div className="mx-auto container relative pl-12 pr-12 pb-12 pt-4 ">
          <figure
            className="absolute h-full md:hidden w-36 -right-16 opacity-10"
            style={{
              backgroundImage: "url(/assets/decorations/filter_shape.svg)",
            }}
          />
          <ul className="max-w-8xl mx-auto grid lg:grid-cols-3 md:grid-cols-1 grid-cols-1 space-between gap-y-5 lg:max-w-5xl 2xl:max-w-8xl lg:gap-16 2xl:gap-2 lg:-mt-12 2xl:mt-0">
            <motion.li
              whileHover={{ scale: 1.1 }}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              className="max-w-sm relative mx-auto mt-32 w-full secondary-gradient-background-shadow text-white border-r-4 border-b-2 md:border-r-[10px] md:border-b-8 border-b-black border-r-black shadow-black shadow-lg"
            >
              <div className="px-5 h-full py-12 before:-top-24 before:sm:-top-32 before:right-5 secondary-gradient-background before:absolute before:md:-top-44 before:2xl:-top-56 before:md:right-0 z-0 before:w-11/12 sm:before:w-8/12 before:lg:w-9/12 before:h-full before:content[''] before:bg-[url('../assets/phone.svg')] before:bg-contain before:bg-no-repeat before:bg-top before:md:bg-center">
                <div className="flex bg-[#117FF5] p-2 md:p-4">
                  <img
                    className="mr-4"
                    src="/assets/purple_star.svg"
                    alt="purple_star"
                  />
                  <h3 className="font-extrabold italic text-base md:text-2xl lg:text-lg 2xl:text-2xl">
                    FAST-PACED
                  </h3>
                </div>
                <p className="mt-4 text-sm lg:text-sm 2xl:text-base text-justify">
                  Jump into real-time battles designed for quick, chaotic
                  action.
                </p>
              </div>
            </motion.li>
            <motion.li
              whileHover={{ scale: 1.1 }}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1, transition: { delay: 0.2 } }}
              viewport={{ once: true }}
              className="max-w-sm mx-auto relative mt-32 w-full secondary-gradient-background-shadow text-white border-r-4 border-b-2 md:border-r-[10px] md:border-b-8 border-b-black border-r-black shadow-black shadow-lg"
            >
              <div className="px-5 h-full py-12 before:-top-32 before:right-5 secondary-gradient-background before:absolute before:md:-top-44 before:2xl:-top-56 before:md:right-0 z-0 before:w-11/12 sm:before:w-8/12 before:lg:w-9/12 before:h-full before:content[''] before:bg-[url('../assets/shield.svg')] before:bg-contain before:bg-no-repeat before:bg-top before:md:bg-center">
                <div className="flex bg-[#117FF5] p-2 md:p-4">
                  <img
                    className="mr-4"
                    src="/assets/purple_star.svg"
                    alt="purple_star"
                  />
                  <h3 className="font-extrabold italic text-base md:text-2xl lg:text-lg 2xl:text-2xl">
                    CO-OP
                  </h3>
                </div>
                <p className="mt-4 text-sm lg:text-sm 2xl:text-base text-justify">
                  Team up or get outplayed. In LOP, coordination wins.
                </p>
              </div>
            </motion.li>
            <motion.li
              whileHover={{ scale: 1.1 }}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1, transition: { delay: 0.4 } }}
              viewport={{ once: true }}
              className="max-w-sm mx-auto relative mt-32 w-full secondary-gradient-background-shadow text-white border-r-4 border-b-2 md:border-r-[10px] md:border-b-8 border-b-black border-r-black shadow-black shadow-lg"
            >
              <div className="px-5 h-full py-12 before:-top-32 before:right-5 secondary-gradient-background before:absolute before:md:-top-44 before:2xl:-top-56 before:md:right-0 z-0 before:w-11/12 sm:before:w-8/12 before:lg:w-9/12 before:h-full before:content[''] before:bg-[url('../assets/award.svg')] before:bg-contain before:bg-no-repeat before:bg-top before:md:bg-center">
                <div className="flex bg-[#117FF5] p-2 md:p-4">
                  <img
                    className="mr-4"
                    src="/assets/purple_star.svg"
                    alt="purple_star"
                  />
                  <h3 className="font-extrabold italic text-base md:text-2xl lg:text-lg 2xl:text-2xl">
                    COMPETE & RISE
                  </h3>
                </div>
                <p className="mt-4 text-sm lg:text-sm 2xl:text-base text-justify">
                  Compete in global tournaments. <br />
                  Win matches, climb the ranks, and keep your legend alive.
                </p>
              </div>
            </motion.li>
          </ul>
        </div>
        {/* Decoration */}
        <figure className="relative after:absolute after:h-[3px] after:bg-black after:w-full after:top-3 after:z-20 after:left-0 before:absolute before:md:w-1/2 before:w-7/12 before:left-0 before:top-0 before:z-10 mt-3 before:border-b-[20px] before:border-r-[20px] before:border-b-[#FFC112] bg-black before:border-r-transparent text-white h-14 pl-10 sm:pl-20 pr-10" />
      </section>

      {/* LORE */}
      <section className="relative z-20 border-b-[80px] border-b-black flex flex-col-reverse lg:flex-row overflow-hidden justify-between game_background  pt-10 lg:pt-5 2xl:pt-10 3xl:pt-20 text-white">
        {/* Girl power */}
        <motion.span
          className="
          bg-left-top 
          -top-40 
          lg:-top-4 
          2xl:-top-24 
          3xl:-top-20
          z-10 
          w-full 
          h-full 
          bg-no-repeat 
          absolute 
          hidden 
          lg:block 
          2xl:w-[120%] 
          2xl:h-[120%] 
          lg:right-[8rem]
          2xl:-right-[8rem]
          3xl:-right-[22rem]
          -right-16"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={dropInWhiteStripeGame}
          style={{
            backgroundImage: "url(/assets/decorations/white_small_bench.svg)",
          }}
        />
        <motion.span
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={dropInWhiteStripeGame}
          className="
          bg-left-top 
          -top-40
          z-10 
          w-full 
          h-full 
          bg-no-repeat 
          absolute 
          hidden 
          lg:block 
          right-[1rem]
          xl:-right-[4rem] 
          2xl:-right-[2rem] 
          3xl:-right-[12rem] 
          "
          style={{
            backgroundImage: "url(/assets/decorations/white_large_bench.svg)",
          }}
        />
        <span
          className="block lg:hidden bg-left-bottom  z-10 w-[120%] h-[120%] bg-no-repeat absolute -bottom-[3rem] left-0"
          style={{
            backgroundImage: "url(/assets/decorations/white-large-mobile.svg)",
          }}
        />
        <span
          className="block lg:hidden bg-left-bottom  z-10 w-full h-full bg-no-repeat absolute -bottom-[15rem] -left-0"
          style={{
            backgroundImage: "url(/assets/decorations/white-large-mobile.svg)",
          }}
        />
        <aside className="flex items-end shrink-0">
          <img
            src="/assets/girl_force.webp"
            alt="jEU DE FORCE"
            title="GAME"
            className="w-96 -left-0 lg:w-auto lg:h-[666px] 2xl:h-[800px] 2xl:-mt-10 self-end relative z-30 mx-auto lg:mx-0 xl:left-6 2xl:left-10 3xl:left-40"
          />
          {/* Gold bench */}
          <img
            src="/assets/gold_bench.svg"
            alt=""
            title="GAME"
            className="absolute left-0 -bottom-1 z-20 md:-bottom-8 lg:-bottom-20 xl:-bottom-16"
          />
          {/* White bench */}
          <img
            src="/assets/white_bench.svg"
            alt=""
            title="GAME"
            className="absolute left-0 -bottom-1 z-20 md:-bottom-8 lg:-bottom-20 xl:-bottom-11"
          />
          {/* Decorations */}
          {/* <figure className="before:w-20 before:h-[1400px] before:-z-0 before:-top-20 before:bg-pink-100 before:-rotate-45 before:absolute after:w-28 after:h-[1024px] after:-z-0 after:-top-28 after:bg-pink-100 after:-rotate-45 after:absolute" /> */}
        </aside>
        {/* Description */}
        <article className="flex lg:ml-auto z-10 lg:mx-0 max-w-8xl flex-col items-start lg:w-7/12 pb-10 lg:pb-0 lg:mb-10">
          <h2 className="curved-trapezium mx-auto lg:mr-0 lg:-ml-20 2xl:-ml-10 text-6xl md:text-8xl inline-block pt-1 pb-3 bg-[#25191E] text-shadow-blue px-14 md:px-20 md:py-4 font-bold italic">
            STORY
          </h2>
          <aside className="right-trapezium mx-auto w-full text-sm md:text-base flex flex-col justify-between bg-[#FF7BA300] xl:-mt-6 lg:bg-[#25191E] grow xl:mb-8 lg:pl-28 2xl:pl-48 pt-12 pb-6 lg:pr-20">
            <div className="w-full max-w-3xl px-8 text-justify">
              <p className="font-montserrat text-base lg:text-lg xl:text-xl leading-relaxed">
                People who shaped history are reunited in the{" "}
                <strong>Heaven of Legends</strong>, a realm beyond time where
                egos clash and glory fades.
                <br />
                <br />
                They believed they would be remembered forever. But{" "}
                <strong>the Oblivion</strong>, slowly erases their names,
                devouring everything that is no longer remembered.
                <br />
                <br />
                To resist the Oblivion, Da Vinci and Daedalus built an arena
                where Legends battle for <strong>Legacy Stones</strong>,
                immortalizing their memory before it fades.
                <br />
                <br />
                They no longer fight for power or fame… but to be remembered.
                <br />
                <br />
              </p>
            </div>
          </aside>
        </article>
        {/* Right particle */}
        <img
          src="/assets/particle.svg"
          alt="flash"
          title="Game"
          className="absolute right-0 -top-20 h-52 lg:h-80 z-20"
        />
      </section>

      {/* Stay Connected */}
      {/* ChatBox */}
      {/*<ChatBox webhookUrl={process.env.REACT_APP_WEBHOOK_URL} />*/}
      <Footer />
    </section>
  );
};

export default Index;
